// import configData from "@/config";
const isProd = process.env.NODE_ENV === 'production';
const isBeta = process.env.NODE_ENV === 'beta';

let setting = {
  "apiBaseUrl": 'http://127.0.0.1:8000/api/v1/',
  "timeZone": 'Asia/Tokyo',
  "S3": {
    region: 'ap-northeast-1',
    "audio": {
      "bucket" : "digin-audio-beta",
      "path" : "audio/",
      "source" : "https://digin-audio-beta.s3-ap-northeast-1.amazonaws.com/"
    },
    "mp3": {
      "bucket" : "digin-mp3-beta",
      "path" : "audio/",
      "source" : "https://digin-mp3-beta.s3.ap-northeast-1.amazonaws.com/" // or use cloudfront?
    },
    "wav": {
      "bucket" : "digin-wav-beta",
      "path" : "audio/",
      "source" : "https://digin-wav-beta.s3-ap-northeast-1.amazonaws.com/"
      // 因為上傳到digin-audio-production會導致目前的轉檔lambda被觸發，所以開新的bucket
    },
    "albumPhoto" : {
      "bucket" : "digins3-beta",
      "path" : "album_photo/",
      "source" : "https://digins3-beta.s3.ap-northeast-1.amazonaws.com/"
    },
    "creatorPhoto" : {
      "bucket" : "digins3-beta",
      "path" : "creator_photo/",
      "source" : "https://digins3-beta.s3.ap-northeast-1.amazonaws.com/"
    },
    "recommend" : {
      "bucket" : "digins3-beta",
      "path" : "recommend_ablum/",
      "source" : "https://digins3-beta.s3.ap-northeast-1.amazonaws.com/"
    },
    "emailAttachment" : {
      "bucket" : "digins3-beta",
      "path" : "email_attachment"
    },
    "inquiry" : {
      "bucket" : "digin-inquiry-beta",
      "path" : "file/",
      "source": "https://digin-inquiry-beta.s3.ap-northeast-1.amazonaws.com/"
    }
  }
};

const betaSetting = {
  "apiBaseUrl": 'https://dev2-digin.digin-music.net/api/v1/',
};

if (isBeta) {
  setting = {
    ...setting,
    ...betaSetting
  };
}

const prodSetting = {
  "apiBaseUrl": 'https://digin.digin-music.net/api/v1/',
  "S3": {
    region: 'ap-northeast-1',
    "audio": {
      "bucket" : "digin-audio-production",
      "path" : "audio/",
      "source" : "https://digin-audio-production.s3-ap-northeast-1.amazonaws.com/"
    },
    "mp3": {
      "bucket" : "digin-mp3-production",
      "path" : "audio/",
      "source" : "https://digin-mp3-production.s3.ap-northeast-1.amazonaws.com/" // or use cloudfront?
    },
    "wav": {
      "bucket" : "digin-wav-production",
      "path" : "audio/",
      "source" : "https://digin-wav-production.s3-ap-northeast-1.amazonaws.com/"
      // 因為上傳到digin-audio-production會導致目前的轉檔lambda被觸發，所以開新的bucket
    },
    "albumPhoto" : {
      "bucket" : "digins3-production",
      "path" : "album_photo/",
      "source" : "https://digins3-production.s3.ap-northeast-1.amazonaws.com/"
    },
    "creatorPhoto" : {
      "bucket" : "digins3-production",
      "path" : "creator_photo/",
      "source" : "https://digins3-production.s3.ap-northeast-1.amazonaws.com/"
    },
    "recommend" : {
      "bucket" : "digins3-production",
      "path" : "recommend_ablum/",
      "source" : "https://digins3-production.s3.ap-northeast-1.amazonaws.com/"
    },
    "emailAttachment" : {
      "bucket" : "digins3-production",
      "path" : "email_attachment"
    },
    "inquiry": {
      "bucket": "digin-inquiry-production",
        "path": "file/",
        "source": "https://digin-inquiry-production.s3.ap-northeast-1.amazonaws.com/"
      }
  }
};

if (isProd) {
  setting = {
    ...setting,
    ...prodSetting
  };
}

export default setting;
